import useId from '../utils/useId';
import * as React from 'react';
export const HRSvg = React.forwardRef(function HRSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#fi_FlagIcon-HR__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M2 2a2 2 0 0 0-2 2v2h16V4a2 2 0 0 0-2-2H2Z',
        fill: '#E25950',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M0 10v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2H0Z',
        fill: '#43458B',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M0 6v4h16V6H0Z',
        fill: '#F6F9FC',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.121 5.379A3 3 0 0 0 8 4.5m0 0a3 3 0 0 0-2.121.879',
        stroke: '#fff',
        strokeWidth: 1.5,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6 6h4v2.5a2 2 0 1 1-4 0V6Z',
        fill: '#EAEEF3',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6 7h1v1H6v1h1v1h-.323a2 2 0 0 0 .323.232V10h1v.5a1.99 1.99 0 0 0 1-.268V10h.323a2 2 0 0 0 .614-1H9V8h1V7H9V6H8v1H7V6H6v1Zm2 1h1V7H8v1Zm0 1v1h1V9H8Zm0 0V8H7v1h1Z',
        fill: '#E25950',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1 6H0v4h1V6Zm14 0v4h1V6h-1Z',
        fill: '#EAEEF3',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.121 5.129A3 3 0 0 0 8 4.25',
        stroke: '#43458B',
        strokeWidth: 1.5,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8 4.25a3 3 0 0 0-2.121.879',
        stroke: '#45B2E8',
        strokeWidth: 1.5,
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `fi_FlagIcon-HR__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(0 2)',
          d: 'M0 0h16v12H0z',
        }),
      ),
    ),
  );
});
HRSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var HR = {
  category: 'flag',
  colorable: false,
  name: 'HR',
  svg: HRSvg,
};
